export const COOLDOWN_PERIODS = [
    0, // First attempt - no cooldown
    30, // Second attempt - 30 seconds
    60, // Third attempt - 1 minute
    5 * 60, // Fourth attempt - 5 minutes
    10 * 60, // Fifth attempt - 10 minutes
];
